import { Component, OnInit } from '@angular/core';
import { DocumentModel } from '../../../../shared/models/document.model';
import { AbreCuentasService } from '../../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';

@Component({
  selector: 'app-front-document-info',
  templateUrl: './front-document-info.component.html',
  styleUrls: ['./front-document-info.component.scss'],
})

/**
 * Summary  The component to Front Document info view
 */
export class FrontDocumentInfoComponent implements OnInit {

  documentInfo: DocumentModel;
  /**
   * Summary Constructor by defintion of services and charge Document Info
   * @param abrecuentasService
   */
  constructor(
    public copyService: CopyService,
    private abrecuentasService: AbreCuentasService,
    ) {
  }

  ngOnInit() {
    this.documentInfo = this.abrecuentasService.getDocumentInfo();
  }

}
